module.exports = __webpack_public_path__ + "img/signal-bars-fair.b138f76f.svg";